import { createContext } from 'react';
import { settings, type AppContextValue } from '@/config';

const AppContext = createContext(settings as unknown as AppContextValue);

type CrawlConfig = Record<string, unknown>;

export const NewCrawlContext = createContext({
  config: {} as CrawlConfig,
  setConfig: (_config: CrawlConfig) => {},
  jobPage: '',
  setJobPage: (_page: string) => {},
  isSubmitted: false,
  setIsSubmitted: (_submitted: boolean) => {},
  canceled: false,
  setCanceled: (_canceled: boolean) => {}
});

export const NewSerpContext = createContext({
  serpId: '',
  setSerpId: (_id: string) => {},
  isSubmitted: false,
  setIsSubmitted: (_submitted: boolean) => {},
  step: 1,
  setStep: (_step: number) => {}
});

export const RemoveCrawlContext = createContext({
  start_url: '',
  setStart_url: (_url: string) => {},
  jobPage: '',
  setJobPage: (_page: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const RemoveMassiveContext = createContext({
  keyword: [] as string[],
  setkeyword: (_keywords: string[]) => {},
  task_id: '',
  setTaskId: (_id: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const RemoveClusteringContext = createContext({
  keyword: [] as string[],
  setkeyword: (_keywords: string[]) => {},
  task_id: '',
  setTaskId: (_id: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const PauseMassiveContext = createContext({
  delayModal: false,
  showStopModal: false,
  setDelayModal: (_open: boolean) => {},
  setShowStopModal: (_open: boolean) => {},
  task_id: '',
  setTaskId: (_id: string) => {}
});

export const RemoveSerpContext = createContext({
  keyword: '',
  setKeyword: (_keyword: string) => {},
  serpId: '',
  setSerpId: (_id: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const RemovePlannerContext = createContext({
  taskId: 'WEWEW',
  setTaskId: (_id: string) => {},
  keyword: '',
  setKeyword: (_keyword: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const RemoveAnalysisContext = createContext({
  analysisId: '',
  setAnalysisId: (_id: string) => {},
  analysisUrl: false as string | boolean,
  setAnalysisUrl: (_url: string | boolean) => {},
  show: false,
  setShow: (_show: boolean) => {},
  status: 6,
  setStatus: (_status: number) => {}
});

export const RemoveGscContext = createContext({
  domain: '',
  setDomain: (_domain: string) => {},
  account: '',
  setAccount: (_account: string) => {},
  hostNameId: '',
  setHostNameId: (_id: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const RemoveAiContentContext = createContext({
  id: '',
  setId: (_id: string) => {},
  keyword: '',
  setKeyword: (_keyword: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export const RemoveAiKeywordsContext = createContext({
  id: '',
  setId: (_id: string) => {},
  subject: '',
  setSubject: (_subject: string) => {},
  show: false,
  setShow: (_show: boolean) => {}
});

export default AppContext;
